//获取产品配置
export const getProductNameSate = state => {
  return state.productNameState
}
//获取单产品是否显示个人中心可用额度
export const getAvailableLimitState = state => {
  return state.availableLimitState
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js